import React from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/it';
import '../css/App.css';
import { FaSquare } from 'react-icons/fa';

moment.locale('it');

function TabellaPianoFerie({ startDate, endDate, lavoratori, pianoFerieData }) {

    const getDatesInRange = (start, end) => {
        const dates = [];
        let currentDate = moment(start);
        const lastDate = moment(end);
        while (currentDate <= lastDate) {
            dates.push(currentDate.format('YYYY-MM-DD'));
            currentDate.add(1, 'days');
        }
        return dates;
    };

    const dates = getDatesInRange(startDate, endDate);

    const renderHeaders = () => (
        <tr>
            <th className="inEvidenza sticky-col first-col align-middle bordiSpessi">Lavoratore</th>
            {dates.map(date => {
                const isSunday = moment(date).day() === 0;
                const thClassName = `inEvidenza text-center bordiSpessi ${isSunday ? 'giorno-domenica' : ''}`;
                return (
                    <th key={date} className={thClassName}>
                        <div>{moment(date).format('dddd')}</div>
                        <div>{moment(date).format('DD/MM/YY')}</div>
                    </th>
                );
            })}
        </tr>
    );

    const getCellData = (lavoratoreId, date) => {
        const feriePermessiGiorno = pianoFerieData[lavoratoreId]?.[date] || [];
        if (feriePermessiGiorno.length === 0) {
            return { content: null, className: '' };
        }

        const isFerie = feriePermessiGiorno.some(item => item.tipo === 'FERIE');
        if (isFerie) {
            return { content: '', className: 'giorno-ferie text-center' };
        }

        const permessi = feriePermessiGiorno
            .filter(item => item.tipo === 'PERMESSO')
            .sort((a, b) => moment.utc(a.inizio).diff(moment.utc(b.inizio)));

        if (permessi.length > 0) {
            const orari = permessi.map(p =>
                `${p.inizio}-${p.fine}`
            );
            const content = orari.map((orario, index) => (
                <React.Fragment key={index}>
                    {orario}
                    {index < orari.length - 1 ? <br /> : null}
                </React.Fragment>
            ));
            return { content: content, className: 'giorno-permesso text-center' };
        }

        return { content: null, className: '' };
    };

    const renderRows = () => {
        const sortedLavoratori = [...lavoratori].sort((a, b) => {
            const cognomeCompare = a.cognome.localeCompare(b.cognome);
            if (cognomeCompare !== 0) return cognomeCompare;
            return a.nome.localeCompare(b.nome);
        });

        return sortedLavoratori.map((lavoratore, index) => (
            <tr key={lavoratore.id}>
                <td className="sticky-col first-col align-middle bordiSpessi">
                    <Link
                        to={`/gestioneferiepermessi?lavoratoreid=${lavoratore.id}&lavoratorenome=${encodeURIComponent(lavoratore.nome + ' ' + lavoratore.cognome)}`}
                        id={`link-lavoratore-${index}`}
                        className="link-lavoratore"
                    >
                        {lavoratore.cognome} {lavoratore.nome}
                    </Link>
                </td>
                {dates.map((date, indexDate) => {
                    const { content, className: leaveClassName } = getCellData(lavoratore.id, date);
                    const isSunday = moment(date).day() === 0;
                    const tdClassName = `cella-piano-ferie bordiSpessi ${isSunday ? 'giorno-domenica' : ''} ${leaveClassName}`;
                    return (
                        <td key={`${lavoratore.id}-${date}`} id={`${index}-${indexDate}`} className={tdClassName}>
                            {content}
                        </td>
                    );
                })}
            </tr>
        ));
    };

    return (
    <>
        <div className='legenda'>
            <FaSquare className='boxLegendaFerie'></FaSquare> <span>ferie  </span> <FaSquare className='boxLegendaPermesso'></FaSquare> <span>permesso</span>
        </div>
        <div className="table-responsive table-piano-ferie-container">
            <Table bordered hover size="sm" id="piano_ferie_table" className="table-piano-ferie">
                <thead className="sticky-header">
                    {renderHeaders()}
                </thead>
                <tbody>
                    {renderRows()}
                </tbody>
            </Table>
        </div>
    </>
);
}

export default TabellaPianoFerie;